import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  getPagedContracts as getPagedContractsApi,
  addOwnContracts as addOwnContractsApi,
  getContractDetail as getContractDetailApi,
  getOwnContractReview as getOwnContractReviewApi,
  getContractsStandartRates as getContractsStandartRatesApi,
  getOldContractsRates as getOldContractsRatesApi,
  getContractsToPartner as getContractsToPartnerApi,
  addReferralLinkDetailsForLanguage as addReferralLinkDetailsForLanguageApi,
} from "../../helpers/ServiceHelpers/backend_helper";

export const getPagedContracts = createAsyncThunk(
  "contracts/getPagedContracts",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getPagedContractsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addOwnContracts = createAsyncThunk(
  "contracts/addOwnContracts",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = addOwnContractsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOwnContractReview = createAsyncThunk(
  "contracts/getOwnContractReview",
  async (id: any) => {
    try {
      const response = getOwnContractReviewApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getContractDetail = createAsyncThunk(
  "contracts/getContractDetail",
  async (data: { contractId: any; skip: number; take: number }) => {
    try {
      const response = await getContractDetailApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getContractsStandartRates = createAsyncThunk(
  "contracts/getContractsStandartRates",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getContractsStandartRatesApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getOldContractsRates = createAsyncThunk(
  "contracts/getOldContractsRates",
  async (id: any) => {
    try {
      const response = getOldContractsRatesApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getContractsToPartner = createAsyncThunk(
  "contracts/getContractsToPartner",
  async (id: any) => {
    try {
      const response = getContractsToPartnerApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addReferralLinkDetailsForLanguage = createAsyncThunk(
  "contracts/addReferralLinkDetailsForLanguage",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = addReferralLinkDetailsForLanguageApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
